module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/ear_nose-3dd5163a47a8e4236933ae109265b995.png";